import { HTTPError } from './http.model';

export class ApiError extends HTTPError {
  body: any;
  code?: string;
  details?: string;

  constructor(response: Response, body: any) {
    super(response);

    this.code = body.code;
    this.message = body.message;
    this.details = body.details;
  }
}
